import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-upload\">\n<style type=\"text/css\">\n\t#icon-upload .st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M5,22h14c0.6,0,1-0.4,1-1V7h-5V2H5C4.4,2,4,2.4,4,3v18C4,21.6,4.4,22,5,22z\" />\n<path class=\"st0\" d=\"M15,2l5,5\" />\n<path class=\"st0\" d=\"M10.5,17.5l5-5l-2-2l-5,5v2H10.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol